import type { Props } from './Svg'
import { Svg } from './Svg'

export function UserIcon(props: Props) {
  return (
    <Svg width="18" height="18" {...props}>
      <path d="M9 8.25a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM4.5 15.75v-1.5a3 3 0 0 1 3-3h3a3 3 0 0 1 3 3v1.5" />
    </Svg>
  )
}
